<template>
        <div class="wrapper">
            <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
                <div class="str-logo">
                    <img
                        :src="$root.serverBasePath + '/strata.png'"
                        alt="Strata Connex"
                        height="49px"
                    />
                </div>

                <div class="content-wrapper">
                    <div>
                        <div class="main-section-content">
                            <!-- if login -->
                            <div
                            v-if="this.authLogin == 'login'"
                            class="login-sec"
                            >
                                <h1 class="head-title">I love how easy it is to work with tradies now with Strata Connex.</h1>
                                <div
                                class="sidebar-review d-flex flex-row"
                                >
                                    <div>
                                        <img
                                            src="l1.png"
                                            class="bg-img img-fluid"
                                            alt="contractor"
                                        />
                                    </div>
                                    <div>
                                        <p class="pl-3 pt-1 dept">
                                            <span
                                                style="color:#6E7191; font-size:16px; font-weight:600;"
                                                >Trade Contractor</span
                                            ><br/>
                                            <span
                                                class="text-sm"
                                                style="font-weight: 400; color:#6E7191; font-size:14px;margin-bottom: 0;display:block"
                                                >Infinity Management</span
                                            >
                                        </p>
                                    </div>
                                </div>
                                <div class="login-img">
                                    <img
                                        class="img-fluid"
                                        :src="$root.serverBasePath + '/logon.png'"
                                        alt="Strata Connex"
                                    />
                                </div>
                            </div>
                            <!-- login ends -->

                            <!-- if signup -->
                            <div
                                v-if="this.authLogin == 'register'"
                                class="sign-up"
                            >
                                <h1 class="head-title">
                                    You’re a few clicks away from creating your account!
                                </h1>

                                <div class="features">
                                    <div class="feature">
                                        <i
                                            class="fa fa-check fa-lg"
                                            aria-hidden="true"
                                        ></i>
                                        <p>One time compliance registration</p>
                                    </div>

                                    <div class="feature">
                                        <i
                                            class="fa fa-check fa-lg"
                                            aria-hidden="true"
                                        ></i>
                                        <p>Share your compliance profile</p>
                                    </div>

                                    <div class="feature">
                                        <i
                                            class="fa fa-check fa-lg"
                                            aria-hidden="true"
                                        ></i>
                                        <p>
                                            Social proof your business with
                                            reviews
                                        </p>
                                    </div>

                                    <div class="feature">
                                        <i
                                            class="fa fa-check fa-lg"
                                            aria-hidden="true"
                                        ></i>
                                        <p>
                                            Improve your business relationships
                                        </p>
                                    </div>
                                </div>
                                <div class="signup-img">
                                    <img src="register.png" class="bg-img img-fluid"/>
                                </div>
                            </div>
                            <!-- signup ends -->
                        </div>
                    </div>
                    <div v-if="error" class="alert alert-success" v-text="error"></div>

                    <LoginComponent
                        v-if="this.authLogin == 'login'"
                        :resetPassword="passwordreset"
                        @whoami="whoami"
                    />

                    <RegisterComponent v-if="this.authLogin == 'register'"/>
                </div>

                <footer-component></footer-component>
            </b-overlay>
        </div>
</template>

<script>
import { Form, HasError } from "vform";
import GoogleLogin from "vue-google-login";
import FooterComponent from "../../../pages/includes/FooterComponent.vue";
import LoginComponent from "@frontendPages/Authentication/LoginComponent.vue";
import RegisterComponent from "@frontendPages/Authentication/RegisterComponent.vue";
// import RegisterText from "@frontendPages/Authentication/RegisterText.vue";

Vue.component(HasError.name, HasError);

export default {
    components: {
        GoogleLogin,
        FooterComponent,
        RegisterComponent,
        LoginComponent
        // RegisterText,
    },
    props: ["passwordreset", "authLogin"],
    data() {
        return {
            subPage: "login",
            loginText: "text",
            params: {
                client_id:
                    "241606855058-96bb8snkq7b4qsj5n02f2b3ukr7jmvbd.apps.googleusercontent.com"
            },
            renderParams: {
                width: 250,
                height: 50,
                longtitle: true
            },
            form: new Form({
                email: "",
                password: "",
                device_name: "web",
                remember: 0
            }),
            googleerror: "",
            error:""
        };
    },
    mounted() {
        //
    },
    methods: {
        redirectToRoot() {
            this.$router.push('/');
        },
        whoami() {
            axios.post("whoami").then(response => {
                 this.error = response.data.error;
                if (response.data && response.data.has_auth) {
                    if (response.data.force_redirect) {
                        // use  r for super admin panel
                        window.location.href = response.data.force_redirect;
                        return;
                    }

                    sessionStorage.setItem('authenticatedUserToken', response.data.vuex_data.user.remember_token);
                    this.$root.$data.loggedInUserToken = response.data.vuex_data.user.remember_token;


                    this.$store.commit(
                        "setUserLoggedIn",
                        response.data.vuex_data
                    );
                    window.axios.defaults.headers.common["Authorization"] =
                        "Bearer " + response.data.token;
                    if (
                        !response.data.vuex_data.user.phone_verified_at &&
                        response.data.vuex_data.role == "contractor" &&
                        response.data.vuex_data.invited_user == false
                    ) {
                        // checking if phone is verified
                        this.$router.push({
                            name: "verify-phone"
                        });
                    } else if (
                        !response.data.vuex_data.user.email_verified_at
                    ) {
                        // checking if email is verified
                        if (
                            this.$route.query.redirectFrom &&
                            this.$route.query.redirectFrom.indexOf(
                                "/verify-email/"
                            ) >= 0
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "verify-email"
                            });
                        }
                    } else if (response.data.vuex_data.role == "manager") {
                        // handling incomplete registration of manager
                        if (
                            !response.data.vuex_data.business &&
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 1}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 2}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "completed" &&
                            this.$route.query.redirectFrom &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "manager-dashboard"
                            });
                        }
                    } else if (response.data.vuex_data.role == "contractor") {
                        // handling incomplete registration of contractor
                        if (
                            !response.data.vuex_data.business &&
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 1}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 2}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "completed" &&
                            this.$route.query.redirectFrom &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "contractor-dashboard"
                            });
                        }
                    }
                }
                this.$root.$data.bsLoader = false;
            });
        },
        onSuccess(googleUser) {
            axios
                .post("api/socialLogin", {
                    type: "google",
                    token: googleUser.tc.access_token
                })
                .then(response => {
                    if (response.data.vuex_data != null) {
                        this.$store.commit(
                            "setUserLoggedIn",
                            response.data.vuex_data
                        );
                        window.axios.defaults.headers.common["Authorization"] =
                            "Bearer " + response.data.token;
                        if (response.data.vuex_data.role == "manager") {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 2}
                            });
                        } else if (
                            response.data.vuex_data.role == "contractor"
                        ) {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 2}
                            });
                        }
                    } else {
                        this.googleerror = response.data.error;
                    }
                });
        },
        linkedIn() {
            axios
                .post(
                    "api/socialLogin",
                    {
                        type: "linked_in"
                    },
                    {
                        headers: {"Access-Control-Allow-Origin": "*"}
                    }
                )
                .then(response => {
                });
            // This only gets the user information: id, name, imageUrl and email
        },

        changeSubpageTo(page) {
            this.subPage = page;
        },
        changeLogintextTo(text) {
            this.loginText = text;
        }
    }
};
</script>


<style scoped>
/* @media screen and (min-width: 1200px) {
    .sign-up {
        position: relative;
        top: -60px;
    }
} */

@media screen and (max-width: 991px) {
    .login-img,
    .signup-img {
        display: flex;
        justify-content: center;
    }
}
</style>
